<template>
    <div>
        <div v-if="init">
            <el-button type="success" @click="add">新增</el-button>
        </div>
        <el-tree :data="data" show-checkbox node-key="id" default-expand-all :props="defaultProps"
            :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="margin-right:25px">{{ node.label }}</span>
                <span>
                    <el-button type="text" size="mini" @click="() => append(data)">
                        增加
                    </el-button>
                    <el-button type="text" size="mini" @click="() => edit(data)">
                        修改
                    </el-button>
                    <el-button type="text" size="mini" @click="() => remove(node, data)">
                        删除
                    </el-button>
                </span>
            </span>
        </el-tree>
        <el-dialog title="权限信息" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="forms">
                <el-form-item label="页面名称" prop="name" :label-width="formLabelWidth">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="页面路径" prop="url" :label-width="formLabelWidth">
                    <el-input v-model="form.url" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="add">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'admin',
        data() {
            return {
                data: [],
                init: false,
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                dialogFormVisible: false,
                formLabelWidth: '120px',
                form: {
                    id: 0,
                    name: '',
                    parent_id: 0,
                    url: ''
                },
                rules: {
                    name: { required: true, message: '请输入页面名称' },
                    url: { required: true, message: '请输入页面路径' },
                },
            }
        },
        created() {
            this.getList();
        },
        methods: {
            getList() {
                this.$http.get('/manage/device-menu/nopage-list').then(results => {
                    if (results['data']['data'].length == 0) {
                        this.init = true;
                    } else {
                        this.data = results['data']['data'];
                    }
                });
            },
            append(data) {
                this.dialogFormVisible = true;
                if (this.$refs['forms'] != undefined) {
                    this.$refs['forms'].resetFields()
                }
                this.form.id = 0;
                this.form.name = null;
                this.form.parent_id = data.id;
                this.form.url = null;
            },
            edit(data) {
                this.dialogFormVisible = true;
                this.form.id = data.id;
                this.form.name = data.name;
                this.form.parent_id = data.parent_id;
                this.form.url = data.url;
            },
            add() {
                this.$refs['forms'].validate(valid => {
                    if (valid) {
                        if (this.form.id == 0) {
                            this.$http.post('/manage/device-menu/save', this.form).then((rs) => {
                                if (rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.dialogFormVisible = false;
                                    this.getList();
                                } else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        } else {
                            this.$http.post('/manage/device-menu/update', this.form).then((rs) => {
                                if (rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.dialogFormVisible = false;
                                    this.getList();
                                } else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            remove(node, data) {
                if (confirm('确认要删除吗？')) {
                    this.$http.post('/manage/device-menu/delete', [data.id]).then((rs) => {
                        if (rs.data.code == 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.dialogFormVisible = false;
                            const parent = node.parent;
                            const children = parent.data.children || parent.data;
                            const index = children.findIndex(d => d.id === data.id);
                            children.splice(index, 1);
                        } else {
                            this.$message({
                                message: rs.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .search-add {
        margin-bottom: 10px;
    }
</style>